<!-- <div style="position:fixed;margin:10px;z-index:1;bottom:0px" class="hidden-print">
    <div class="ui big black label visible-xs">x-Small</div>
    <div class="ui big black label visible-sm">Small</div>
    <div class="ui big black label visible-md">Medium</div>
    <div class="ui big black label visible-lg">Large</div>
</div> -->

<app-headerbar *ngIf="!hideRoutes() && user"></app-headerbar>
<router-outlet></router-outlet>